import React from 'react';
import { useMediaQuery } from 'react-responsive';
import Header from '../../components/header';
import Header2 from '../../components/header2';
import Footer from '../../components/footer';
import VideoBackground from './VideoBackground';

export default function WelcomePage() {



    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isHD = useMediaQuery({ query: '(min-width: 769px) and (max-width: 1280px)' });
    const isFullHD = useMediaQuery({ query: '(min-width: 1281px)' });


    return (
        <div>
            <Header2></Header2>
            <Header></Header>

            <div>
                {isMobile && (
                    <div>
                        <VideoBackground></VideoBackground>
                    </div>
                )}
                {isHD && (
                    <div>
                        <VideoBackground></VideoBackground>
                    </div>
                )}
                {isFullHD && (
                    <div>
                        <VideoBackground></VideoBackground>
                    </div>
                )}
            </div>
{/*             <div className="bg-black spotify">
                <div className="spotify-player" style={{ maxWidth: '400px', width: '100%' }}>
                    <iframe
                        title="spotify-player"
                        style={{ borderRadius: "12px"}}
                    src="https://open.spotify.com/embed/playlist/6ff3jEIwYZyFgiNwadFbvy?utm_source=generator&theme=0"
                    width="100%"
                    height="420"
                    frameBorder="0"
                    allowfullscreen=""
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                    loading="lazy">
                    </iframe>
                </div>
            </div> */}
            <Footer></Footer>
        </div>
    )
}